import * as Yup from 'yup';
import 'yup-phone-lite';
import { LeadType } from '../../../models/dealer-prospect.model';

Yup.setLocale({
  mixed: {
    required: 'Required Field',
  },
});

export const DealerProspectSchema = Yup.object().shape({
  date: Yup.string().required(),
  // division: Yup.string().required().oneOf(Object.values(Division)),
  teamMemberName: Yup.string().required().min(2).max(50),
  leadType: Yup.string().required().oneOf(Object.values(LeadType)),
  leadTypeName: Yup.string().required().min(2).max(100),
  dealershipName: Yup.string().required().min(2).max(100),
  // Contact Name and everything below: optional
  contactFirstName: Yup.string().optional().max(50),
  contactLastName: Yup.string().optional().max(50),
  phone: Yup.string()
    .transform((v) => (v === '' ? undefined : v))
    .optional()
    .nullable()
    .phone('US', 'Please enter a valid phone number'),
  email: Yup.string()
    .transform((v) => (v === '' ? undefined : v))
    .optional()
    .nullable()
    .email('Please enter a valid email'),
  physicalAddress: Yup.object().shape({
    addressLine1: Yup.string().optional(),
    addressLine2: Yup.string().nullable().optional(),
    city: Yup.string().optional(),
    state: Yup.string().optional(),
    zipCode: Yup.string().optional(),
  }),
});

export const dealerProspectInitialValues: any = {
  date: new Date().toISOString().split('T')[0],
  // division: Division.TSF,
  teamMemberName: '',
  leadType: LeadType.Event,
  leadTypeName: '',
  dealershipName: '',
  contactFirstName: '',
  contactLastName: '',
  phone: '',
  email: '',
  physicalAddress: {
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    zipCode: '',
  },
};
